import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import App from './App';
import BirdDetails from './components/BirdDetails';
import NotFound from './components/NotFound';
import UpdateLogs from './pages/updateLogs';
import HotspotRedirect from './components/HotspotRedirect';
import './index.css';

const Root = () => {
    useEffect(() => {
        // Disable right-click context menu
        const handleContextMenu = (e) => {
            e.preventDefault();
        };

        // Disable dev tools key shortcuts
        const handleKeyDown = (e) => {
            if (
                e.key === "F12" ||
                (e.ctrlKey && e.shiftKey && (e.key === "I" || e.key === "J" || e.key === "C")) ||
                (e.ctrlKey && e.key === "U")
            ) {
                e.preventDefault();
            }
        };

        document.addEventListener("contextmenu", handleContextMenu);
        document.addEventListener("keydown", handleKeyDown);

        // Clean up event listeners on unmount
        return () => {
            document.removeEventListener("contextmenu", handleContextMenu);
            document.removeEventListener("keydown", handleKeyDown);
        };
    }, []);
    return (
        <Router>
            <Routes>
                {/* Main app route */}
                <Route path="/" element={<App />} />

                {/* Dynamic page route */}
                <Route path="/:id" element={<BirdDetails />} />

                {/* Catch-all 404 page */}
                <Route path="*" element={<NotFound />} />

                {/* Update logs route */}
                <Route path='/updates' element={<UpdateLogs />} />

                {/* Hotspot redirect routes */}
                <Route path="/location/:id" element={<HotspotRedirect type="location" />} />
                <Route path="/checklist/:id" element={<HotspotRedirect type="checklist" />} />
            </Routes>
        </Router>
    );
};

ReactDOM.render(<Root />, document.getElementById('root'));
